// extracted by mini-css-extract-plugin
module.exports = {"container":"home_container__1OjW9","child":"home_child__iKDdt","roundedborder":"home_roundedborder__3Xd98"};